import React, { Component, forwardRef } from 'react'
import './custom-style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import MenuLeftNav from "./MenuLeftNav";
import { Field, FieldArray, reduxForm, getFormValues } from 'redux-form'
import asyncValidate from './asyncValidate';
import Divider from '@material-ui/core/Divider';
import { connect } from "react-redux";
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import * as auth from "../../store/ducks/auth.duck";
import { push } from 'object-path';
import clsx from "clsx";
import { Link, Redirect } from "react-router-dom";
import SweetAlert from 'react-bootstrap-sweetalert';
import Loader from 'react-loader-advanced';
import { Helmet } from 'react-helmet'
import axiosAPI from '../../api/Scoreboardapi';

library.add(fas)
const renderField = ({
    input,
    label,
    type,
    disabled,
    placeholder,
    isAsterisk,
    meta: { asyncValidating, touched, error }
}) => (
        <div className="formgroup">
            <div className="row">
                <label className="custom-label col-sm-2 text-right" style={{ color: "#3f4047", marginTop: 7 }}> {label}{isAsterisk && <sup style={{ color: "red" }}> *</sup>} </label>

                <div className="col-sm-6">
                    <div className={asyncValidating ? 'async-validating' : ''}>
                        <input {...input} type={type} placeholder={placeholder} disabled={disabled} className="form-control" />
                        {touched && error && <span className="error-msg text-danger">{error}</span>}

                    </div>
                </div>
            </div>
        </div>
    )
const renderCheckboxField = ({
    input,
    label,
    type,
    checked,
    id,
    txtId,
    data,
    onClick,
    meta: { asyncValidating, touched, error }
}) => (
        <div className="formgroup render-checkbox ">
            <div className="">
                <div className={asyncValidating ? 'async-validating form-inline' : 'form-inline'}>
                    <input {...input} checked={checked || false} type={type} id={txtId} onClick={onClick} placeholder={label} value={data} className="form-control " style={{ height: 18, width: 18, color: "#575962" }} />
                    <label className="ml-3 checkboxText screen-custom-label" style={{ color: "#575962" }} htmlFor={txtId}>{label}</label>
                </div>
            </div>
        </div>
    )

const validate = values => {
    const errors = {}
    const requiredFields = [
        'display_name',
    ]
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'This field is required'
        }
    })
    return errors
}

class EditLogo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            display_name: null,
            name: null,
            role: [],
            rolePermissions: [],
            isChecked: false,
            name: null,
            description: null,
            alert: null,
            display_name: null,
            is64baseimage: null,
            isimageName: null,
            imgSrc: null,
            enable_referral_specific_link: false,
        }
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        this.props.fetchLogoDetailRequest({
            Referralkey: window.location.href.split("/")[5],
            OrganizationId: window.location.href.split("/")[6]
        })
    }

    sendEmailToMappedUsers = async () => {
        var data = {
            "Referralkey": window.location.href.split("/")[5],
            "OrganizationId": window.location.href.split("/")[6],
        };
        await axiosAPI.post('/logo/sendemailtomappedusers', data)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.logoDetail) {
            // console.log('nextProps.logoDetail',nextProps.logoDetail.liLogoByIDresponse[0].isSleepScreenerEnabled);
            if (nextProps.logoDetail && nextProps.logoDetail != this.props.logoDetail) {
                this.setState({
                    //imgSrc: nextProps.logoDetail.liLogoByIDresponse[0] && nextProps.logoDetail.liLogoByIDresponse[0].logoPath ? nextProps.logoDetail.logoImagePath : '',
                    enable_referral_specific_link: (nextProps.logoDetail.liLogoByIDresponse[0] && nextProps.logoDetail.liLogoByIDresponse[0].isSleepScreenerEnabled && nextProps.logoDetail.liLogoByIDresponse[0].isSleepScreenerEnabled === '1') ? true : false,
                });
            }
        }
        if (nextProps.saveLogoDetailResponse) {
            if (nextProps.saveLogoDetailResponse && nextProps.saveLogoDetailResponse != this.props.saveLogoDetailResponse) {
                if (nextProps.saveLogoDetailResponse.success) {
                    this.setState({ isSaveLogo: false });
                    // this.logoAlert(nextProps.saveLogoDetailResponse.message, 'success');
                    this.setState({ redirect: true })
                    if(this.state.enable_referral_specific_link) {
                        this.sendEmailToMappedUsers();
                    }
                }
                else {
                    this.setState({ isSaveLogo: false });
                    this.logoAlert(nextProps.saveLogoDetailResponse.message, 'failure');
                }
            }
        }
    }

    logoAlert(msg, type) {
        let getAlert = '';
        if (type == 'success') {
            getAlert = () => (
                <SweetAlert
                    success
                    title={msg}
                    onConfirm={() => this.hideAlert(true)}
                >
                </SweetAlert>
            );

        } else {
            getAlert = () => (
                <SweetAlert
                    error
                    title={msg}
                    onConfirm={() => this.hideAlert(false)}
                >
                </SweetAlert>
            );
        }

        this.setState({
            alert: getAlert()
        });
    }
    hideAlert(isRedirected) {
        this.setState({
            alert: null
        });
        if (isRedirected) {
            this.props.reset();
            this.setState({ redirect: true })
        }
    }
    onSubmit = (formProps) => {
        if (!this.state.isError) {

            let imageName = '';
            if(this.isimageName === undefined)
            {
                imageName = (this.props.logoDetail.liLogoByIDresponse[0] && this.props.logoDetail.liLogoByIDresponse[0].logoPath) ? this.props.logoDetail.liLogoByIDresponse[0].logoPath : '';
            }
            else
            {
                imageName = window.location.href.split("/")[5] + '.' + this.isimageName;
                // window.location.href.split("/")[5] + '.' + this.isimageName,
            }
            var enableReferralSpecificLink = null;
            if(localStorage.getItem('referralTypeToBeEdited') == 'Facility') {
                enableReferralSpecificLink = this.state.enable_referral_specific_link ? '1' : '0';
            }
            this.setState({ isSaveLogo: true });
            this.props.saveLogoDetailRequest({
                Referralkey: window.location.href.split("/")[5],
                OrganizationId: window.location.href.split("/")[6],
                CurrentImageName: imageName,
                ImageData: this.is64baseimage == undefined ? "" : this.is64baseimage,
                enable_referral_specific_link: enableReferralSpecificLink,
            });
        }
    }
    getFiles(files) {
        this.setState({ files: files })
        this.setState({ isError: false, error: '' })
        if (files.name.length > 0) {
            if (files.size.split(' ')[0] / 1024 > 5) {
                this.setState({ isError: true, error: 'image should be smaller than 5 MB' })
            }
            var type = files.name.split('.')[1] // image/jpg, image/png, image/jpeg...
            // allow jpg, png, jpeg, bmp, gif, ico
            var Extension = files.name.split('.')[1].toLowerCase();
            if (Extension == "gif" || Extension == "png" || Extension == "bmp" || Extension == "jpeg" || Extension == "jpg") {

                this.is64baseimage = files.base64.split(',')[1];
                this.isimageName = files.name.split('.')[1]
            }
            else {
                this.setState({ isError: true, error: 'Only file with the .gif, .png, .bmp, .jpeg, .jpg extension are allowed' })
            }

        }
        else {
            this.is64baseimage = null;
            this.isimageName = null;
        }
    }

    handleCheckboxChange = (e) => {
        // update the state with the new array of options
        this.setState({ enable_referral_specific_link: !this.state.enable_referral_specific_link });
    }

    render() {
        const spinner = <span  className="loader"></span>;

        if (this.state.redirect) {
            return <Redirect to="/logos" />
        }
        const { handleSubmit, pristine, reset, submitting, formValues, change } = this.props;

        this.state.role = this.props.rolePermissionListResponse;
        const { loading } = this.props;

        var pageTitle = 'Actions: '+localStorage.getItem('referralNameToBeEdited');

        return (
            <>
            <Helmet>
                <title>Referral Management | Scorecard</title>
            </Helmet>

            <div className="main-content-body UserList">
                {this.state.alert}
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-3 left-side-bar">
                            <MenuLeftNav isExpand={{ expand: "logos", active: "logos" }}></MenuLeftNav>
                        </div>
                        <div className="col-lg-9 mt-3 right-content-wrap  mb-5">
                            <div className="order-and-adherence-detail">
                                <span className="manage-user-title">{pageTitle}</span>
                                <div className="font-500 user-list-table">
                                    <div className="card-header" style={{ backgroundColor: 'white' }}>
                                        <div className="card-title"><h5 style={{ color: 'black' }}>Edit Referral</h5></div>
                                    </div>
                                    <Divider />
                                    <div className="row p-3">
                                        <div className="col-lg-12">
                                            <div style={{ maxWidth: '100%' }}>
                                            <Loader show={loading} message={spinner}>
                                                <form className="form-horizontal" onSubmit={handleSubmit(this.onSubmit)}>
                                                    {(localStorage.getItem('referralTypeToBeEdited') == 'Facility') &&<>
                                                    <div className="row">
                                                        <h5 className="screener-heading mt-4" style={{ color: 'black' }}>Sleep Screener Link</h5>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-sm-1 padding-block"></div>
                                                        <div className="col-sm-9">
                                                            <div className="form-group">
                                                                <Field
                                                                    type="checkbox"
                                                                    margin="normal"
                                                                    name="enable_referral_specific_link"
                                                                    data="enable_referral_specific_link"
                                                                    txtId="enable_referral_specific_link"
                                                                    label="Enable referral-specific link"
                                                                    component={renderCheckboxField}
                                                                    checked={this.state.enable_referral_specific_link}
                                                                    onChange={this.handleCheckboxChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div></>}
                                                    <Divider style={{ marginTop: 30 }} />
                                                    <div className="row mt-3 mb-3"  >
                                                        <div className="col-sm-2 mt-3 text-right"></div>
                                                        <div className="col-sm-9 text-left userprofile-btn">
                                                            <button style={{ width: 120 }}
                                                                id="kt_login_signin_submit"
                                                                type="submit"
                                                                disabled={submitting || this.state.isError}
                                                                className={`btn btn-primary btn-elevate kt-login__btn-primary button-big mr-2 ${clsx(
                                                                    {
                                                                        "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.isSaveLogo
                                                                    }
                                                                )}`}
                                                            >
                                                                Submit
                                                    </button>
                                                            <Link style={{ width: 120 }}
                                                                to="/logos"
                                                                className={`btn btn-default btn-no`}>
                                                                Cancel
                                                    </Link>
                                                        </div>

                                                    </div>
                                                </form>

                                            </Loader>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        )
    }


}
function mapStateToProps(state) {
    return {
        logoDetail: state.auth.fetchLogoDetailSuccess != undefined ? state.auth.fetchLogoDetailSuccess : '',
        saveLogoDetailResponse: state.auth.saveLogoDetailResponse != undefined ? state.auth.saveLogoDetailResponse : '',
        loading: state.auth.loading,
    }
}

EditLogo = reduxForm({
    form: 'EditLogo',
    validate,
    asyncValidate,
    enableReinitialize: true,
    destroyOnUnmount: true
})(EditLogo);

const mapDispatchToProps = (dispatch) => {
    return {
        fetchLogoDetailRequest: ({
            Referralkey,
            OrganizationId
        }) => dispatch(auth.actions.fetchLogoDetailRequest({
            Referralkey,
            OrganizationId
        })),
        saveLogoDetailRequest: ({
            OrganizationId,
            Referralkey,
            CurrentImageName,
            ImageData,
            enable_referral_specific_link
        }) => dispatch(auth.actions.saveLogoDetailRequest({
            OrganizationId,
            Referralkey,
            CurrentImageName,
            enable_referral_specific_link
        }))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EditLogo);